module.exports = __webpack_public_path__ + "static/img/download-anzhuo.e938688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download-anzhuo.png
// module id = pql4
// module chunks = 1